export enum ServiceClassEnum {
  UNDEFINED = 0,
  CLASSIC = 1,
  PREMIUM = 2,
  LUXE = 3
}
